import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import { ConfigService } from './config.service';
import { Role } from '../models/role.model';
import { User } from '../models/user.model';
import { UserPermissions } from '../models/user-permissions.model';
import { ResponseStatus } from '../models/ResponseStatus.model';
import { Observable } from 'rxjs';

@Injectable()
export class UserService {
    
    readonly apiServer: string;
    private readonly _hapApiServer: string;

    constructor(private _configService: ConfigService, private _http: HttpClient) { 
        this.apiServer = this._configService.appSettings.webApiServer + "api/User/";
        this._hapApiServer = _configService.appSettings.IDSApiBaseUrl;
    }	
   
    async getRoles(): Promise<Role[]> {
        return await this._http.get<Role[]>(`${this.apiServer}GetRoles`).toPromise<Role[]>();
    }

    async getUserPermissions(): Promise<UserPermissions> {
        return await this._http.get<UserPermissions>(`${this.apiServer}GetUserPermissions`).toPromise<UserPermissions>();
    }

    async getUsers(mostRecent: boolean, offset: number, totalItems: number, searchText: string, orderBy: string, direction: string): Promise<User[]> {
        const params = new HttpParams()
            .set('mostRecent', mostRecent.toString())
            .set('offset', offset.toString())
            .set('totalItems', totalItems.toString())
            .set('searchText', searchText)
            .set('orderBy', orderBy)
            .set('direction', direction);

        return await this._http.get<User[]>(`${this.apiServer}GetUsers`, { params: params }).toPromise<User[]>();
    }

    async getUsersForPermissions(): Promise<User[]> {
        return await this._http.get<User[]>(`${this.apiServer}GetUsersForPermissions`).toPromise<User[]>();
    }

    async setUser(user: User): Promise<number> {            
        return await this._http.post<number>(`${this.apiServer}SetUser`, JSON.stringify(user)).toPromise<number>();
   }
   async GetCurrentUserRoleName(): Promise<string> {
    return await this._http.get<string>(`${this.apiServer}GetCurrentUserRoleName`).toPromise<string>();
  }
  async GetCurrentUser(): Promise<User> {
    return await this._http.get<User>(`${this.apiServer}GetCurrentUser`).toPromise<User>();
  }
  async checkEmailExist(email: string): Promise<Observable<ResponseStatus>> {
    const params = new HttpParams().set('email', email);
    return  await this._http.get<any>(`${this.apiServer}CheckUserExists`,{ params: params });
  }
}
